import React from 'react';

import { useAppSelector } from 'store/hook';
import { formatAreaByUnitSystem, getAreaUnitLabel, getDisplayUnitSource } from 'utils/helpers/units';

import { ContentContainer } from './IncentivesProposalModalInfo';
import { useIncentivesContext } from '../IncentivesContext';

const IncentivesProposalModalInfoUnit = () => {
  const { selectedProposalUnit } = useIncentivesContext();
  const { selectedCommunity, selectedParentCommunity } = useAppSelector((state) => state.global);
  const unitSource = getDisplayUnitSource(selectedCommunity, selectedParentCommunity);
  const areaUnitLabel = getAreaUnitLabel(unitSource);

  return (
    <ContentContainer>
      <div style={{ fontFamily: 'var(--font-bold)' }}>Unit</div>
      <span>{selectedProposalUnit?.number}</span>
      <span
        style={{
          color: 'var(--text-secondary)',
        }}
      >
        {selectedProposalUnit?.name && <span>{selectedProposalUnit.name} · </span>}
        {selectedProposalUnit?.square_feet && (
          <span>
            {formatAreaByUnitSystem(selectedProposalUnit.square_feet, unitSource)} {areaUnitLabel}
          </span>
        )}
      </span>
    </ContentContainer>
  );
};

export default IncentivesProposalModalInfoUnit;
